/* eslint-disable */
import { useEffect, useRef, useState } from 'react'
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import * as API from '../../../framework/API/api';
import { ENTITYNAME, FILEURL, LOCALSTORAGE_KEY, LOGEVENT, MODULE, NODE_ACTION, PUBLISH_REPORT, PUBLISH_REPORT_CONFIG, PUBLISH_TYPE, ROLETYPE, TOAST_TYPES, TRANSMISSION_PUBLISH_STATUS, } from '../../../framework/constant/constant';
import { useTranslation } from '../../../locale/useTranslation';
import { ConfirmDeleteAlert } from '../../../ConfirmAlert';
import { utility } from '../../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../../components/EditPageHeader';
import NodeEditForm from '../../masters/NodeEditForm';
import { ContextMenu } from 'primereact/contextmenu';
import { Popup } from "@progress/kendo-react-popup";
import ExportVodForm from './ExportVodForm';
import BossDialog from '../../../components/BossDialog';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import CollectionSelection from '../../../framework/forms/CollectionSelection';
import CreateTransmissionOfferForm from '../vodOffer/createTransmissionOfferForm';
import ToastNotification from '../../../components/ToastNotification';

const NodeTreeViewForm = (props) => {

    const { height, handleSelectedNodes, isMultiSelect = false, isSaveButton = false, onClose, selectedNodeIds = [], showCatalogue = true, selectedCatalogueId = null, isFromMedia = false, selectedNodeId = null, setIsRefreshOffers, isShowAllNodes = false } = props;

    const lang = useTranslation();
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const [treeData, setTreeData] = useState([]);
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [hashNodes, setHashNodes] = useState([]);
    const [selectedNode, setSelectedNode] = useState({});
    const [selectedNodes, setSelectedNodes] = useState([]);
    const [showNodeModal, setShowNodeModal] = useState({
        show: false,
        isEdit: false
    });
    const cm = useRef();
    const cmCatalogue = useRef();
    const [selectedCatalogue, setSelectedCatalogue] = useState(null);
    const optionsMenu = useRef(null);
    const [showExportForm, setShowExportForm] = useState({ show: false, publishReport: null, title: "" });
    const [footerMessage, setFooterMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTreeData, setFilteredTreeData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAttachOffers, setShowAttachOffers] = useState(false);
    const [showCreateAndAttchOffersForm, setShowCreateAndAttchOffersForm] = useState(false);

    const hideAllContextMenus = () => {
        cm.current?.hide?.();
        cmCatalogue.current?.hide?.();
        optionsMenu.current?.hide?.();
    };

    useEffect(() => {
        const handleOutsideMenuClick = (event) => {
            if (event?.target?.closest?.('.p-contextmenu')) {
                return;
            }
            hideAllContextMenus();
        };

        document.addEventListener('mousedown', handleOutsideMenuClick);
        document.addEventListener('touchstart', handleOutsideMenuClick);
        document.addEventListener('scroll', hideAllContextMenus, true);
        window.addEventListener('resize', hideAllContextMenus);

        return () => {
            document.removeEventListener('mousedown', handleOutsideMenuClick);
            document.removeEventListener('touchstart', handleOutsideMenuClick);
            document.removeEventListener('scroll', hideAllContextMenus, true);
            window.removeEventListener('resize', hideAllContextMenus);
        };
    }, []);


    useEffect(() => {
        loadCombo();
    }, [isShowAllNodes]);

    const loadCombo = async () => {
        try {
            setSelectedNode({});
            setIsLoading(true);

            let nodeRes = await API.getNodesWithTransmissionCount();

            let nodeData = nodeRes?.data || [];

            // if (isFromMedia) {
            //     nodeData = nodeData.filter(n => {
            //         const imageGroupName = n?.ImageGroup?.Name?.toLowerCase();
            //         return imageGroupName !== 'sea' && imageGroupName !== 'ris';
            //     });
            // }

            if (selectedCatalogueId) {
                let catalogueFilterNodeData = nodeData.filter(n => n.Catalogue._id === selectedCatalogueId);
                setHashNodes(catalogueFilterNodeData);
                const tree = buildTreeStructure(catalogueFilterNodeData);
                setTreeData(tree);
                setFilteredTreeData(tree);
                setIsLoading(false);
                return;
            }

            if (!selectedNodeIds?.length) {
                setHashNodes(nodeData);
                const tree = buildTreeStructure(nodeData);
                setTreeData(tree);
                setFilteredTreeData(tree);
                setIsLoading(false);
                return;
            }

            const nodeMap = new Map(nodeData.map(n => [n._id, n]));
            const collectedNodes = new Set();

            // Get all children
            const collectChildren = (node) => {
                nodeData.forEach(n => {
                    if (n.ParentNode === node._id) {
                        collectedNodes.add(n);
                        collectChildren(n);
                    }
                });
            };

            // Get all parents
            const collectParents = (node) => {
                if (node.ParentNode) {
                    const parent = nodeMap.get(node.ParentNode);
                    if (parent) {
                        collectedNodes.add(parent);
                        collectParents(parent);
                    }
                }
            };
            let selectedNodes = nodeData;

            if (!selectedNodeIds.includes(null)) {
                selectedNodes = nodeData.filter(n =>
                    selectedNodeIds.includes(n._id)
                );
            }

            selectedNodes.forEach(node => {
                collectedNodes.add(node);
                collectChildren(node);
                collectParents(node);
            });

            const finalNodes = Array.from(collectedNodes);

            setHashNodes(finalNodes);
            const tree = buildTreeStructure(finalNodes);
            setTreeData(tree);
            setFilteredTreeData(tree);

            setIsLoading(false);

        } catch (error) {
            console.error('Error loading nodes:', error);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Error loading nodes: ' + error });
        }
    };

    useEffect(() => {
        if (searchTerm && searchTerm.trim()) {
            const filtered = filterTree(treeData, searchTerm);
            setFilteredTreeData(filtered);
            const allNodeIds = new Set();
            const collectIds = (nodes) => {
                nodes.forEach(n => {
                    if (n._id) {
                        allNodeIds.add(n._id);
                    }
                    if (n.children && n.children.length > 0) {
                        collectIds(n.children);
                    }
                });
            };
            collectIds(filtered);
            setExpandedNodes(allNodeIds);
        } else {
            setFilteredTreeData(treeData);
        }
    }, [searchTerm, treeData]);

    const getExpandedNodeIdsForSelection = (node, nodeMap) => {
        const expanded = new Set();

        let current = node;
        while (current?.ParentNode) {
            expanded.add(current.ParentNode);
            current = nodeMap.get(current.ParentNode);
        }

        if (showCatalogue && node?.Catalogue?._id) {
            expanded.add(node.Catalogue._id);
        }

        return expanded;
    };

    useEffect(() => {
        if (!selectedNodeId || !hashNodes.length) return;

        console.log("selectedNodeId", selectedNodeId);

        const nodeMap = new Map(hashNodes.map(n => [n._id, n]));
        const matchedNode = nodeMap.get(selectedNodeId);

        if (!matchedNode) return;

        setSelectedNode(matchedNode);
        handleSelectedNodes && handleSelectedNodes(matchedNode);

        const expanded = getExpandedNodeIdsForSelection(matchedNode, nodeMap);
        setExpandedNodes(expanded);
    }, [selectedNodeId, hashNodes]);

    const filterTree = (nodes, term) => {
        if (!term || term.trim() === '') return nodes;

        const searchLower = term.toLowerCase().trim();

        const filterNode = (node) => {
            // Check if current node name matches
            const nodeNameMatch = node?.Name?.toLowerCase().includes(searchLower) || node?.CSID?.toLowerCase().includes(searchLower);

            // Process children if they exist
            let filteredChildren = [];
            let hasMatchingDescendants = false;

            if (node.children && node.children.length > 0) {
                // Recursively filter children
                node.children.forEach(child => {
                    const result = filterNode(child);
                    if (result) {
                        filteredChildren.push(result);
                        hasMatchingDescendants = true;
                    }
                });
            }

            if (nodeNameMatch) {
                return {
                    ...node,
                    children: node.children || [], // Return ALL children if node matches
                    isSearchMatch: true
                };
            } else if (hasMatchingDescendants) {
                return {
                    ...node,
                    children: filteredChildren,
                    isSearchMatch: false
                };
            }

            return null;
        };

        const filtered = [];
        nodes.forEach(node => {
            const result = filterNode(node);
            if (result) {
                filtered.push(result);
            }
        });

        return filtered;
    };

    const buildTreeStructure = (nodeData) => {

        const nodeMap = new Map();

        // create node map
        nodeData.forEach((n) => {
            nodeMap.set(n._id, {
                ...n,
                children: [],
                level: 0,
            });
        });

        // catalogue grouping
        const catalogueMap = new Map();

        nodeData.forEach((n) => {

            const catId = n?.Catalogue?._id;

            if (!catalogueMap.has(catId)) {
                catalogueMap.set(catId, {
                    _id: catId,
                    Name: n?.Catalogue?.Description,
                    nodes: [],
                    isCatalogue: true,
                });
            }

            catalogueMap.get(catId).nodes.push(n._id);
        });

        const CatalogueRoots = [];

        catalogueMap.forEach((cat) => {

            const rootNodes = [];

            // build parent-child structure
            cat.nodes.forEach((id) => {

                const node = nodeMap.get(id);

                if (node.ParentNode) {

                    const parentNode = nodeMap.get(node.ParentNode);

                    if (parentNode) {
                        parentNode.children.push(node);
                    } else {
                        rootNodes.push(node);
                    }

                } else {
                    rootNodes.push(node);
                }
            });

            // assign level dynamically
            const assignLevels = (nodes, level = 1) => {

                nodes.forEach((node) => {

                    node.level = level;

                    if (node.children?.length) {
                        assignLevels(node.children, level + 1);
                    }
                });
            };

            // VOD Catalogue = 0
            // root = 1
            // Movies = 2
            // Asian = 3
            assignLevels(rootNodes, 1);

            // sort only level >= 3
            const sortTree = (nodes) => {

                // sort only deeper submenu
                if (nodes?.length && nodes[0]?.level >= 3) {
                    nodes.sort((a, b) =>
                        (a.Name || "").localeCompare(b.Name || "")
                    );
                }

                nodes.forEach((node) => {

                    if (node.children?.length) {
                        sortTree(node.children);
                    }
                });
            };

            sortTree(rootNodes);

            CatalogueRoots.push({
                _id: cat._id,
                Name: cat.Name,
                children: rootNodes,
                isCatalogue: true,
                level: 0,
            });
        });

        if (!showCatalogue) {

            const roots = [];

            nodeMap.forEach((node) => {

                if (!node.ParentNode || !nodeMap.has(node.ParentNode)) {
                    roots.push(node);
                }
            });

            return roots;
        }

        return CatalogueRoots;
    };

    const setLevels = (nodes, level = 0) => {
        nodes.forEach(n => {
            n.level = level;
            if (n.children?.length) {
                setLevels(n.children, level + 1);
            }
        });
    };


    const toggleNode = (node) => {
        setExpandedNodes(prev => {
            const newSet = new Set(prev);
            if (newSet.has(node._id)) {
                newSet.delete(node._id);
                if (node.isCatalogue) {
                    setSelectedNode({});
                    setSelectedNodes([]);
                    handleSelectedNodes && handleSelectedNodes({});
                }
            } else {
                newSet.add(node._id);
            }
            return newSet;
        });
    };

    const getAllDescendantIds = (node) => {
        let ids = [node._id];
        if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
                ids = [...ids, ...getAllDescendantIds(child)];
            });
        }
        return ids;
    };

    const isNodeSelected = (nodeId) => {
        if (isMultiSelect) {
            return selectedNodes.some(cat => cat._id === nodeId);
        } else {
            return selectedNode?._id === nodeId;
        }
    };

    const contextMenuCancel = () => {
        setSelectedNode({});
        setSelectedNodes([]);
        handleSelectedNodes && handleSelectedNodes({});
    };

    const renderTreeNode = (nodeValue, level = 0) => {
        const hasChildren = nodeValue.children && nodeValue.children.length > 0;
        const isExpanded = expandedNodes.has(nodeValue._id);
        const isSelected = isNodeSelected(nodeValue._id);
        const isHidden = nodeValue?.isHidden;
        const isActionDelete = nodeValue?.action == NODE_ACTION.Delete;

        let nodeIcon = hasChildren ? (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(0,0,0,0.04)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    color: '#555',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
                title={isExpanded ? "Collapse" : "Expand"}
            >
                {isExpanded ? <i className="fa fa-chevron-down" style={{ fontSize: '12px' }} /> : <i className="fa fa-chevron-right" style={{ fontSize: '12px', marginLeft: '2px' }} />}
            </div>
        ) : (
            <div style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className="fa fa-circle" style={{ fontSize: '5px', color: '#dcdcdc' }} />
            </div>
        );

        let nodeLabel = nodeValue.Name;

        const handleIconClick = (e) => {
            e.stopPropagation();
            if (hasChildren) {
                toggleNode(nodeValue);
            }
        };

        const handleLabelClick = async (e) => {
            e.stopPropagation();
            if (nodeValue.isCatalogue) {
                setSelectedNode({});
                setSelectedNodes([]);
                handleSelectedNodes && handleSelectedNodes({});
                return;
            }
            if (isMultiSelect) {
                const isAlreadySelected = selectedNodes.some(n => n._id === nodeValue._id);

                let updatedSelection;
                if (isAlreadySelected) {
                    updatedSelection = selectedNodes.filter(
                        n => !nodeValue._id.includes(n._id)
                    );
                } else {
                    updatedSelection = [...selectedNodes, nodeValue];
                }
                setSelectedNode(updatedSelection?.length > 0 ? updatedSelection[0] : {});
                setSelectedNodes(updatedSelection);
            } else {
                setSelectedNode(nodeValue);
                setSelectedNodes([nodeValue]);
                !isSaveButton && handleSelectedNodes && handleSelectedNodes(nodeValue);
            }
        };

        return (
            <div key={nodeValue._id}>
                <div
                    className="tree-node"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 8px 8px ' + (level * 20 + 8) + 'px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                        transition: 'background-color 0.2s'
                    }}
                    onClick={handleLabelClick}
                    onMouseEnter={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }}
                    onMouseLeave={(e) => {
                        if (!isSelected) e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();

                        if (nodeValue.isCatalogue) {
                            setSelectedCatalogue(nodeValue);
                            cmCatalogue.current.show(e);
                            return;
                        }

                        if (Object.keys(selectedNode).length == 0 && !isMultiSelect) {
                            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
                            return;
                        }
                        setSelectedNode(nodeValue);
                        cm.current.show(e);
                    }}
                >
                    <span
                        style={{
                            marginRight: '12px',
                            cursor: hasChildren ? 'pointer' : 'default',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={handleIconClick}
                        onMouseEnter={(e) => {
                            if (hasChildren) e.currentTarget.firstChild.style.backgroundColor = 'rgba(0,0,0,0.08)';
                        }}
                        onMouseLeave={(e) => {
                            if (hasChildren) e.currentTarget.firstChild.style.backgroundColor = 'rgba(0,0,0,0.04)';
                        }}
                    >
                        {nodeIcon}
                    </span>
                    <span
                        style={{
                            fontWeight: isSelected ? 'bold' : 'normal',
                            flex: 1,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '6px',
                        }}
                    >
                        {nodeLabel}

                        {!nodeValue.isCatalogue && (
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                {isHidden && <i
                                    className={`pi pi-eye-slash`}
                                    style={{
                                        fontSize: '12px',
                                        color: '#f44336',
                                    }}
                                    title='Hidden'
                                />}

                                {nodeValue?.ImageGroup?.Name?.toLowerCase() === "ris" && (
                                    // <i class="fa-solid fa-sliders"></i>
                                    <i
                                        className="fa-solid fa-sliders"
                                        style={{
                                            fontSize: '14px',
                                            color: '#673ab7',
                                        }}
                                        title="Series"
                                    />
                                )}
                                {nodeValue?.ImageGroup?.Name?.toLowerCase() === "sea" && (
                                    <i
                                        className="fa-solid fa-tv"
                                        style={{
                                            fontSize: '14px',
                                            color: '#009688',
                                        }}
                                        title="Season"
                                    />
                                )}

                                {/* {isFromMedia > 0 &&  <span
                                    style={{
                                        backgroundColor: '#2B76D2',
                                        color: '#fff',
                                        fontSize: '9px',
                                        fontWeight: 600,
                                        padding: '2px 4px',
                                        borderRadius: '5px',
                                        minWidth: '18px',
                                        textAlign: 'center',
                                        lineHeight: '14px',
                                    }}
                                    title={`L${nodeValue.level ?? 0}`}
                                >
                                   {`L${nodeValue.level ?? 0}`}
                                </span>} */}

                                {nodeValue.transmissionCount > 0 && <span
                                    style={{
                                        backgroundColor: '#2B76D2',
                                        color: '#fff',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        padding: '2px 4px',
                                        borderRadius: '5px',
                                        minWidth: '18px',
                                        textAlign: 'center',
                                        lineHeight: '14px',
                                    }}
                                    title={`Transmissions: ${nodeValue.transmissionCount ?? 0}`}
                                >
                                    {nodeValue.transmissionCount ?? "0"}
                                </span>}
                            </span>
                        )}

                        {isActionDelete && <i className="fa fa-trash" style={{ fontSize: '10px', color: '#f44336', marginLeft: '4px' }} title="Marked for Deletion" />}
                    </span>
                </div>

                {hasChildren && isExpanded && (
                    <div className="tree-children">
                        {nodeValue.children.map(child => renderTreeNode(child, level + 1))}
                    </div>
                )}
            </div>
        );
    };

    const onDeleteSelectedNode = async (action) => {
        try {
            const deleteRes = await API.deleteNode(selectedNode?._id, action);

            if (deleteRes.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Node Deleted Successfully" });
                // Save Logs
                await API.SaveLogs({ event: LOGEVENT.DELETE_NODE, module: MODULE.NODES, data: {}, _id: selectedNode?._id?.toString(), message: deleteRes.message });

                // Update LocalStorage
                let localStorageData = utility.getValue(ENTITYNAME.Nodes);
                if (localStorageData?.data?.length > 0) {
                    const updatedData = localStorageData?.data?.map(n => {
                        if (deleteRes.data.includes(n._id)) {
                            return { ...n, action: action };
                        }
                        return n;
                    });
                    utility.setValue(ENTITYNAME.Nodes, { ...localStorageData, data: updatedData });
                }

                loadCombo();
                setSelectedNode({});
                handleSelectedNodes && handleSelectedNodes({});
            }
            else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: deleteRes.message });
                return;
            }
        }
        catch (error) {
            console.log("error", error.message);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
        }
    }

    const onCancel = () => {
        setSelectedNode({});
        setSelectedNodes([]);
        onClose && onClose();
    }

    const handleSubmit = () => {

        //if selected node has less then level 3 then show alert message
        // if (selectedNodes.some(n => n.level < 3)) {
        // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: " Only nodes at level 3 or deeper can be selected." });
        //     return;
        // }

        let finalData = hashNodes.filter(n => selectedNodes.some(selectedNode => selectedNode._id === n._id));

        handleSelectedNodes && handleSelectedNodes(finalData);
        onCancel();
    }

    const handleHideUnhideNode = async (node, isHidden) => {
        try {
            const updatedNode = { ...node, isHidden: isHidden };

            const res = await API.saveData(ENTITYNAME.Nodes, { _id: node._id, isHidden: isHidden });

            if (res?.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: isHidden ? lang.node_hidden_success_message : lang.node_show_success_message });
                let localStorageData = utility.getValue(ENTITYNAME.Nodes);
                const updatedData = localStorageData?.data?.map(n => n._id === updatedNode._id ? updatedNode : n);
                utility.setValue(ENTITYNAME.Nodes, updatedData);
                // Update treeData to reflect change in UI
                const updateTreeNode = (nodes) => {
                    return nodes.map(n => {
                        if (n._id === updatedNode._id) {
                            return updatedNode;
                        } else if (n.children) {
                            return { ...n, children: updateTreeNode(n.children) };
                        } else {
                            return n;
                        }
                    });
                };

                setTreeData(prevTree => updateTreeNode(prevTree));
                setFilteredTreeData(prevTree => updateTreeNode(prevTree));
                setSelectedNode(updatedNode);
                contextMenuCancel();
            }
        } catch (error) {
            console.error(error);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: isHidden ? lang.node_hidden_error_message : lang.node_show_error_message });
        }
    };

    const exportTranscodingDublist = async ({ node, catalogue }) => {
        let query = [];

        if (catalogue) {
            query = ["catalogue._id", "=", catalogue._id];
        } else if (node) {
            query = ["nodes._id", "in", [node._id]]
        }

        const res = await API.exportTranscodingDublist(query);
        console.log(res);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.fileName)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    let vodPublishReport = PUBLISH_REPORT_CONFIG.filter(item => item.PUBLISH_TYPE == PUBLISH_TYPE.VODCatalogue);

    const optionsMenuModel = [
        {
            label: "Publish",
            icon: 'pi pi-file-excel',
            items: [
                ...vodPublishReport.map
                    (item => ({
                        label: item.label || item.Description,
                        icon: item.icon,
                        command: () => setShowExportForm({ show: true, publishReport: item.SID, title: (item.label || item.Description) })
                    })),
            ]
        },
        {
            label: lang.export_dublist_label,
            icon: 'pi pi-file-excel',
            command: () => exportTranscodingDublist({})
        },
    ];

    const handleAttachOffers = async (offerData = []) => {

        if (offerData?.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No offers found!" });
            return;
        }

        let finalData = {
            node: {
                _id: selectedNode._id,
                CSID: selectedNode.CSID,
                Name: selectedNode.Name
            },
            offers: offerData.map(x => {
                return {
                    _id: x._id,
                    CSID: x.CSID,
                    Title: x.Title,
                }
            })
        };
        let res = await API.nodeAttachOffersLink(finalData);

        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            setIsRefreshOffers && setIsRefreshOffers(true);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            {isSaveButton && <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={onCancel} saveButtonTitle={lang.select_button_text} />}
            <div className="tree-view-wrapper" style={{
                border: '1px solid #ddd',
                backgroundColor: '#fff',
                borderRadius: '4px',
                maxHeight: 'calc(100vh - 150px)',
                height: height ?? 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    margin: '0',
                    fontSize: '15px',
                    borderBottom: '2px solid #ddd',
                    padding: '10px 10px 10px 10px',
                    fontWeight: 'bold',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexShrink: 0
                }}>
                    <span>
                        <span style={{ marginRight: '5px', fontSize: '10px' }}>📋 </span>
                        {lang.nodes_label}
                        {isMultiSelect && selectedNodes.length > 0 && (
                            <span style={{ marginLeft: '10px', fontSize: '12px', color: '#2196F3' }}>
                                ({selectedNodes.length} selected)
                            </span>
                        )}
                    </span>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <RoundButton
                            icon="refresh"
                            onClick={() => loadCombo()}
                            title={lang.edit_node_button_tooltip}
                        />
                        {(selectedNode?._id || selectedNodes.length === 1) && <RoundButton
                            icon="plus"
                            onClick={() => setShowNodeModal({ show: true, isEdit: false })}
                            title={lang.create_node_button_tooltip}
                        />}
                        <button type="button" title={lang.options} onClick={(e) => optionsMenu.current.show(e)} className={`btn btn-default btn-circle btn-my`} >
                            <i className={`fa fa-ellipsis-v img-circle`} ></i>
                        </button>
                    </div>
                </div>
                {/* Search Input */}
                <div style={{ position: 'relative' }}>
                    <input
                        type="text"
                        placeholder={lang.search_nodes_placeholder || "Search nodes..."}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '8px 35px 8px 35px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px',
                            outline: 'none'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#2196F3'}
                        onBlur={(e) => e.target.style.borderColor = '#ddd'}
                    />
                    <i className="pi pi-search" style={{
                        position: 'absolute',
                        left: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#999',
                        fontSize: '14px'
                    }} />
                    {searchTerm && (
                        <i
                            className="pi pi-times"
                            style={{
                                position: 'absolute',
                                right: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999',
                                fontSize: '14px',
                                cursor: 'pointer'
                            }}
                            onClick={() => setSearchTerm('')}
                        />
                    )}
                </div>

                {isLoading ? <Loader height="10vh" /> :

                    <div className="tree-view-container" style={{
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        padding: '10px',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1'
                    }}>
                        <style>
                            {`
                    .tree-view-container::-webkit-scrollbar {
                        width: 8px;
                    }
                    .tree-view-container::-webkit-scrollbar-track {
                        background: #f1f1f1;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb {
                        background: #888;
                        border-radius: 4px;
                    }
                    .tree-view-container::-webkit-scrollbar-thumb:hover {
                        background: #555;
                    }
                `}
                        </style>
                        {filteredTreeData.length > 0 ? (
                            filteredTreeData.map(node => renderTreeNode(node))
                        ) : (
                            <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                                {lang.no_nodes_found_message}
                            </p>
                        )}
                    </div>}
            </div>
            <ContextMenu
                ref={cm}
                model={[
                    ((selectedNode?._id || selectedNodes.length === 1) && !selectedNode?.isCatalogue) && {
                        label: "Edit",
                        icon: 'pi pi-fw pi-pencil',
                        className: 'p-menuitem-danger',
                        command: () => setShowNodeModal({ show: true, isEdit: true }),
                    },
                    !selectedNode?.isHidden && {
                        label: lang.hide_node_label,
                        icon: "pi pi-fw pi-eye-slash",
                        command: () => handleHideUnhideNode(selectedNode, true),
                    },
                    selectedNode?.isHidden && {
                        label: lang.show_node_label,
                        icon: "pi pi-fw pi-eye",
                        command: () => handleHideUnhideNode(selectedNode, false),
                    },
                    {
                        label: lang.export_dublist_label,
                        icon: "pi pi-fw pi-download",
                        command: () => exportTranscodingDublist({ node: selectedNode }),
                    },
                    {
                        label: lang.create_offers_label,
                        icon: "pi pi-fw pi-plus",
                        command: () => setShowCreateAndAttchOffersForm(true),
                    },
                    {
                        label: lang.attach_offers_label,
                        icon: "pi pi-fw pi-link",
                        command: () => setShowAttachOffers(true),
                    },
                    ...(user?.RoleType?.ID !== ROLETYPE.User
                        ? [
                            {
                                label: lang.delete_button_text,
                                icon: 'pi pi-trash',
                                className: 'p-menuitem-danger',
                                command: () =>
                                    ConfirmDeleteAlert(
                                        () => onDeleteSelectedNode(NODE_ACTION.Delete),
                                        () => { }
                                    )
                            },
                            {
                                label: "Reset Delete",
                                icon: 'pi pi-trash',
                                className: 'p-menuitem-danger',
                                command: () =>
                                    ConfirmDeleteAlert(
                                        () => onDeleteSelectedNode(NODE_ACTION.ResetDelete),
                                        () => { },
                                        "Reset Delete",
                                        "Are you sure you want to reset delete for this node?"
                                    )
                            },
                        ]
                        : []),
                    {
                        label: lang.ref_cancel_label,
                        icon: "pi pi-fw pi-times",
                        command: contextMenuCancel,
                    }
                ].filter(Boolean)}
            />
            <ContextMenu
                ref={cmCatalogue}
                model={[
                    {
                        label: lang.export_dublist_label,
                        icon: "pi pi-fw pi-download",
                        command: () => exportTranscodingDublist({ catalogue: selectedCatalogue }),
                    }
                ]}
            />
            <ContextMenu
                ref={optionsMenu}
                model={optionsMenuModel}
            />

            {showNodeModal.show && <NodeEditForm item={showNodeModal.isEdit ? selectedNode : { ParentNode: selectedNode?._id, Catalogue: selectedNode?.Catalogue }} cancelEdit={() => setShowNodeModal(false)} refresh={loadCombo} />}
            {showExportForm.show &&
                <BossDialog title={showExportForm.title} width='500px' onClose={() => setShowExportForm(false)}>
                    <ExportVodForm setShowExportForm={setShowExportForm} publishReport={showExportForm.publishReport} setFooterMessage={setFooterMessage} isPopup={true} />
                    <div className='text-right mt-3' style={{ position: 'fixed', height: '30px', width: '500px', marginLeft: '-20px', padding: '5px', background: "#3A3633" }}>
                        <span style={{ color: 'white' }}>{footerMessage} </span>
                    </div>
                </BossDialog>
            }
            {showAttachOffers && <CollectionSelection title={lang.select_offers_label} showCreate={true} path="/home/offer" wherestatement={['EndDateTime', '>', utility.getCurrentDate()]} setDataList={handleAttachOffers} closeForm={() => setShowAttachOffers(false)} addButtonTitle={lang.select_button_text} entityname={ENTITYNAME.OFFER} width={"50vw"} />}
            {showCreateAndAttchOffersForm && <CreateTransmissionOfferForm node={selectedNode} cancelEdit={() => setShowCreateAndAttchOffersForm(false)} refreshData={() => { setIsRefreshOffers && setIsRefreshOffers(true) }} />}

        </>
    )
}

export default NodeTreeViewForm;
